import React from "react";
import { Box, LinearProgress, Typography } from "@mui/material";

export interface Props {
  step?: number;
  totalSteps?: number;
  completedAll?: boolean;
}

export const FlowProgress = ({
  step = 1,
  totalSteps = 3,
  completedAll = false,
}: Props): JSX.Element => {
  const getCompletionBarPercent = () => {
    const actualComplete = Math.floor(((step - 1) / totalSteps) * 100);
    const fakeFirstComplete = Math.floor(((1 / totalSteps) * 100) / 2);
    if (completedAll) {
      return 100;
    } else {
      return actualComplete === 0 ? fakeFirstComplete : actualComplete;
    }
  };
  return (
    <>
      <Box display="flex" justifyContent="space-between">
        <Typography>
          <strong>Progress</strong>
        </Typography>
        <Typography variant="body2">
          Step {step} of {totalSteps}
        </Typography>
      </Box>
      <LinearProgress
        sx={{
          mt: 1,
        }}
        variant="determinate"
        value={getCompletionBarPercent()}
        color="secondary"
      />
    </>
  );
};
